import React from 'react';
import {
  generateHeaderMenuList,
  StyledIcon,
} from '../../_helpers/buildHeaderMenuList';
import type { Config } from 'u-next/config';

export const DeskTopMenu: React.FC<{
  options: Config;
}> = ({ options }) => (
  <div className="absolute inset-y-auto right-4 h-full">
    <ul className="flex h-full gap-6">
      {generateHeaderMenuList(options).map(({ url, text, icon }) => (
        <li key={url}>
          <a href={url}>
            <div className="flex h-full items-center gap-1">
              <div className="size-6">
                <StyledIcon jsx={icon} className="size-full object-contain" />
              </div>
              <div className="text-base2 font-bold cst-halt leading-[1.4] text-main-100">
                {text}
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  </div>
);
